import { clamp } from './placement';

export function bindPhotoPlacement(canvas, getState, onChange) {
  const pointers = new Map(); let start = null;
  const snapshot = () => {
    const state = getState(), values = [...pointers.values()];
    if (!values.length) return null;
    const centre = values.length > 1 ? { x: (values[0].x + values[1].x) / 2, y: (values[0].y + values[1].y) / 2 } : values[0];
    return { centre, distance: values.length > 1 ? Math.hypot(values[1].x - values[0].x, values[1].y - values[0].y) : null, placement: { ...state.placement } };
  };
  const down = event => {
    const state = getState(); if (!state.enabled || !state.image || state.placement.locked) return;
    event.preventDefault(); canvas.setPointerCapture(event.pointerId); pointers.set(event.pointerId, { x: event.clientX, y: event.clientY }); start = snapshot();
  };
  const move = event => {
    if (!pointers.has(event.pointerId)) return;
    const state = getState(); if (!state.enabled || state.placement.locked) return;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    const now = snapshot(); if (!start || !state.rect) return;
    const patch = {
      offset_x: clamp(start.placement.offset_x + (now.centre.x - start.centre.x) / state.rect.width, -1.5, 1.5),
      offset_y: clamp(start.placement.offset_y + (now.centre.y - start.centre.y) / state.rect.height, -1.5, 1.5),
    };
    if (now.distance && start.distance) patch.scale = clamp(start.placement.scale * now.distance / start.distance, .15, 5);
    onChange(patch);
  };
  const up = event => { pointers.delete(event.pointerId); start = snapshot(); };
  const wheel = event => {
    const state = getState(); if (!state.enabled || !state.image || state.placement.locked) return;
    event.preventDefault(); event.stopImmediatePropagation();
    onChange({ scale: clamp(state.placement.scale * Math.exp(-event.deltaY * .001), .15, 5) });
  };
  canvas.addEventListener('pointerdown', down); canvas.addEventListener('pointermove', move);
  canvas.addEventListener('pointerup', up); canvas.addEventListener('pointercancel', up); canvas.addEventListener('lostpointercapture', up);
  canvas.addEventListener('wheel', wheel, { passive: false, capture: true });
  return () => {
    canvas.removeEventListener('pointerdown', down); canvas.removeEventListener('pointermove', move);
    canvas.removeEventListener('pointerup', up); canvas.removeEventListener('pointercancel', up); canvas.removeEventListener('lostpointercapture', up);
    canvas.removeEventListener('wheel', wheel, true);
  };
}